module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Light-0e04f00c8b41a9f4dcac2168f70c0fe5.woff";